module.exports = __webpack_public_path__ + "img/customer02.8d4ae72e.png";